import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import DeleteComponent from '../../action/delete.jsx';
import AddRole from './sections/add';
import EditRole from './sections/edit';


const Roles = () => {
    const [roles, setRoles] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [roleId, setRoleId] = useState(null);
    const [filterText, setFilterText] = useState('');
    
    const fetchRoles = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/role?page=${currentPage + 1}`)
            .then(response => {
                setRoles(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching the roles!", error);
                setRoles([]);
            });
    };

    useEffect(() => {
        fetchRoles(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = roles.filter(
        item => item.name.toLowerCase().includes(filterText.toLowerCase())
    );


    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Roles</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Roles</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_role"><i className="fa-solid fa-plus"></i> Add Role</Link>
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-4">
                        <input className="form-control" type="text"
                            placeholder="Search role..." aria-label="Search Input"
                            value={filterText} onChange={(event)=>{
                                setFilterText(event.target.value)
                            }} />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Role Name</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((role) => (
                                                        <tr key={role.id}>
                                                            <td>{role.name}</td>
                                                            <td className="text-end">
                                                                {!(role.name.toLowerCase().includes("admin")) &&
                                                                    <div className="dropdown dropdown-action">
                                                                        <Link to="#" className="action-icon dropdown-toggle"
                                                                            data-bs-toggle="dropdown" aria-expanded="false"
                                                                                onClick={() => setRoleId(`${role.id}`)}>
                                                                                <i className="material-icons">more_vert</i></Link>
                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                            <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                                data-bs-target={`#edit_role_${role.id}`}>
                                                                                    <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                                <DeleteComponent 
                                                                                    url = "role"
                                                                                    id = {role.id}
                                                                                    fetchData={fetchRoles} />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="2">No records found</td>
                                                    </tr>
                                                ) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <AddRole list={fetchRoles}/>
            <EditRole list={fetchRoles} roleId={roleId} />
        </>
    );
}

export default Roles